/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IInspectPanelHeaderProps {
	className?: string;
}

export const InspectPanelHeader: React.FC<IInspectPanelHeaderProps> = ({ children, className }) => {
	const baseClass = BEM("edt-inspect-panel", "header");

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};
